export default "__VITE_ASSET__Dy75fO2Z__"